import React, { useEffect, useState } from 'react';
import './styles.css';
import { useDataProvider, useNotify } from 'react-admin';

const ImageUploadingField = ({ img, id, onRemove, ...props }) => {
  const [image, setImage] = useState<any>({
    id: null,
    url: null,
    localUrl: null,
    isUploading: null,
    file: null,
    Key: null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const dataProvider = useDataProvider();
  const notify = useNotify();

  async function removeImage() {
    try {
      setIsDeleting(true);
      console.log('image: ', image);
      let response = await onRemove({
        ...image,
        index: props.index,
        error: error,
      });
      setIsDeleted(true);
      return response;
    } catch (err) {
      console.error('err: ', err);
    } finally {
      setIsDeleting(false);
    }
  }

  const handleCopyPath = (event) => {
    let path = image.url ? image.url : '';
    console.log('Image path: ', path);
    navigator.clipboard.writeText(path);
    notify(`Copied "${path}" to clipboard`, 'info');
  };

  const uploadImage = async (file) => {
    try {
      setError('');
      console.log('Start uploading image: ', image);
      let response = await dataProvider.storeBlogPostAssetsImageAsync([file]);
      let url = `${process.env.REACT_APP_AWS_S3_URL}/${response.data[0].url}`;
      setImage({
        url: url,
        id: img.id,
        localUrl: img.localUrl,
        isUploading: null,
        file: null,
        Key: response.data[0].url,
      });
      setIsUploaded(true);
    } catch (err: any) {
      console.error('Err image uploading: ', JSON.stringify(err));
      setError(JSON.stringify(err));
      notify(`Err image uploading: ${JSON.stringify(err)}`, 'error');
    } finally {
      setIsUploading(false);
      setIsUploaded(false);
    }
  };

  useEffect(() => {
    setImage({
      url: img.url,
      localUrl: img.localUrl,
      id: img.id,
      isUploading: img.isUploading ? img.isUploading : null,
      file: img.file,
      Key: img.Key,
    });
  }, []);
  useEffect(() => {
    if (image.file) {
      setIsUploading(true);
      uploadImage(image.file);
    }
  }, [image]);
  return (
    <React.Fragment>
      {image.id ? (
        <div className={`image-preview-field`}>
          <button
            type='button'
            disabled={isDeleting || isUploading}
            onClick={removeImage}
          >
            x
          </button>
          <div className='overlay'>
            <div className={`message-box delete${isDeleting ? ' active' : ''}`}>
              <p>deleting...</p>
            </div>
            <div
              className={`message-box upload${isUploading ? ' active' : ''}`}
            >
              <p>uploading...</p>
            </div>
            <div className={`message-box error${error ? ' active' : ''}`}>
              <p>uploading error</p>
            </div>
            {!error && !isUploading && !isDeleting && (
              <div className='copy-button' onClick={handleCopyPath}>
                <p>Copy url</p>
              </div>
            )}
            {error && !isUploading && !isDeleting && !isUploaded && (
              <div
                className='try-button'
                onClick={() => {
                  if (image.file) {
                    setIsUploading(true);
                    uploadImage(image.file);
                  }
                }}
              >
                <p>Try again</p>
              </div>
            )}
          </div>
          <img
            src={image.localUrl ? image.localUrl : image.url}
            alt={id}
            {...props}
          />
          {/* <div
            className={`overlay${isDeleting ? ' deleting' : ''}${
              isUploading ? ' uploading' : ''
            }`}
          >
            <p className='overlay-status'>in process ...</p>
          </div> */}
        </div>
      ) : undefined}
    </React.Fragment>
  );
};

export default ImageUploadingField;
